<template>
  <el-dialog
      :title="fullNameTitle"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="5vh"
  >
    <el-form
        label-width="120px"
        :model="attendanceEmployee.arriveEmployeeDate"
        label-position="top"
        ref="attendanceEmployee"
    >
      <el-row :gutter="20" style="margin-top: 10px">
        <el-col :span="24">
          <div class="shift-card">
            <div class="shift-header">
              <strong>Chấm công đến</strong>
            </div>

            <div class="shift-row">
              <!-- Ảnh đến + upload -->
              <div class="shift-col shift-media">
                <div class="shift-media-title">Ảnh đến</div>
                <image-uploader
                    v-model="attendanceEmployee.arriveEmployeeDate.arrivePictureFile"
                    :preview="attendanceEmployee.arriveEmployeeDate.arrivePicture"
                    placeholder="Tải ảnh đến"
                    :updateAttendance="true"
                    @change="handleImageChange"
                />
                <div class="shift-time">
                  Giờ đến: <span>{{ attendanceEmployee.arriveEmployeeDate.arriveTime | formatTime }}</span>
                </div>
              </div>

              <!-- Ghi chú + thông tin -->
              <div class="shift-col shift-note">
                <div class="shift-media-title">Ghi chú</div>
                <el-input
                    type="textarea"
                    :rows="4"
                    v-model="attendanceEmployee.arriveEmployeeDate.arriveContent"
                    placeholder="Nhập nội dung / ghi chú cho chấm công đến"
                />

                <!-- Thông tin người thực hiện -->
                <div class="shift-status" style="margin-top: 20px;" v-if="attendanceEmployee.arriveEmployeeDate.createdBy">
                  <div v-if="attendanceEmployee.arriveEmployeeDate.createdDate !== attendanceEmployee.arriveEmployeeDate.lastModifieDate">
                    <strong>Chấm công:</strong> {{ attendanceEmployee.arriveEmployeeDate.lastModifieBy }}
                    <div style="margin-top: 6px;" v-if="attendanceEmployee.arriveEmployeeDate.lastModifieBy !== 'Hệ thống'">
                      <strong>Thời gian:</strong> {{ attendanceEmployee.arriveEmployeeDate.lastModifieDate | formatDateTime }}
                    </div>
                  </div>
                  <div v-else>
                    <strong>Chấm công:</strong> {{ attendanceEmployee.arriveEmployeeDate.createdBy }}
                    <div style="margin-top: 6px;"  v-if="attendanceEmployee.arriveEmployeeDate.createdDate !== 'Hệ thống'">
                      <strong>Thời gian:</strong> {{ attendanceEmployee.arriveEmployeeDate.createdDate | formatDateTime }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
          type="danger"
          size="medium"
          @click="closeDialogByButton('attendanceEmployee')"
      >
        <i class="el-icon-circle-close" /> Đóng
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          @click="submitForm('attendanceEmployee')"
      >
        <i class="el-icon-circle-check" /> Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ImageUploader from "@/utils/view/ImageUploader.vue"; // Giả sử bạn đã có component này giống Code 1
import AttendanceEmployeeService from "@/services/EmployeeService/AttendanceEmployeeService";

export default {
  name: "AttendanceArriveEmployeeDialog",
  components: {
    ImageUploader
  },
  props: {
    dialogVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      attendanceEmployee: {
        arriveEmployeeDate: {
          arrivePicture: null,          // URL ảnh hiện tại
          arrivePictureFile: null,      // File mới upload (dùng cho v-model của image-uploader)
          arriveTime: null,
          arriveContent: "",
          createdBy: "",
          createdDate: "",
          lastModifieBy: "",
          lastModifieDate: "",
          id: null
        }
      },
      fullNameTitle: "",
      loadingButton: false,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("dialog-close", false);
      this.resetForm();
    },

    closeDialogByButton() {
      this.closeDialog();
    },

    resetForm() {
      if (this.$refs["attendanceEmployee"]) {
        setTimeout(() => {
          this.$refs["attendanceEmployee"].resetFields();
        }, 200);
      }
      // Reset ảnh
      this.attendanceEmployee.arriveEmployeeDate.arrivePictureFile = null;
      this.attendanceEmployee = { arriveEmployeeDate: {} };
      this.fullNameTitle = "";
    },

    // Xử lý khi image-uploader thay đổi file
    handleImageChange(file) {
      this.attendanceEmployee.arriveEmployeeDate.arrivePictureFile = file;
      // Nếu cần validate file giống cũ, bạn có thể thêm logic ở đây
      const isValidType = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 <= 5;
      if (!isValidType) {
        this.$message.error("Chỉ chấp nhận file JPG hoặc PNG");
        this.attendanceEmployee.arriveEmployeeDate.arrivePictureFile = null;
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không được quá 5MB");
        this.attendanceEmployee.arriveEmployeeDate.arrivePictureFile = null;
      }
    },

    submitForm(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (!valid) {
          this.$message.error("Vui lòng kiểm tra thông tin");
          return;
        }

        const inputData = this.attendanceEmployee.arriveEmployeeDate;
        const formData = new FormData();

        // Append các field text
        formData.append("arriveContent", inputData.arriveContent || "");
        // Nếu có id (update)
        if (inputData.id) {
          formData.append("id", inputData.id);
        }

        // Append file nếu có thay đổi
        if (inputData.arrivePictureFile instanceof File) {
          formData.append("multipartFile", inputData.arrivePictureFile);
        }

        this.loadingButton = true;

        AttendanceEmployeeService.updateArriveContent(inputData.id, formData)
            .then(() => {
              this.$message.success("Lưu chấm công đến thành công");
              setTimeout(() => {
                this.closeDialogByButton();
              }, 500);
            })
            .catch((err) => {
              console.error(err);
              this.$message.error("Lưu chấm công đến thất bại");
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
      });
    },

    getDataArriveRowInitial(row) {
      this.attendanceEmployee = row;
      this.fullNameTitle = "Thông tin chấm công đến: " + (row.attendanceInfoEmployee?.fullName || "");

      // Đảm bảo arrivePictureFile ban đầu là null (chưa upload mới)
      this.attendanceEmployee.arriveEmployeeDate.arrivePictureFile = null;
    },
  }
};
</script>

<style scoped>
/* Copy style từ Code 1 để đồng bộ */

.shift-card {
  padding: 18px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.shift-header {
  font-size: 18px;
  margin-bottom: 12px;
  color: #1f74d4;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

.shift-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.shift-col {
  display: flex;
  flex-direction: column;
}

.shift-media {
  width: 180px;
  align-items: center;
  text-align: center;
}

.shift-note {
  flex: 1;
}

.shift-media-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.shift-time {
  margin-top: 10px;
  color: #4177e2;
  font-size: 16px;
  font-weight: 500;
}

.shift-status {
  margin-top: 20px;
  font-size: 13px;
  line-height: 1.6;
}

.shift-status strong {
  color: #1f74d4;
}

/* Dialog chung */
::v-deep .el-dialog__body {
  max-height: 72vh;
  overflow-y: auto;
  background: #fafbff;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #4da3ff, #1f74d4);
  padding: 16px 20px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 20px !important;
  font-weight: bold;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
}

::v-deep .el-dialog__footer {
  background: #f5f7fa;
  padding: 14px 20px !important;
  border-top: 1px solid #dcdfe6;
}

::v-deep .el-button--success:hover {
  background: #40c463;
  border-color: #40c463;
}

::v-deep .el-button--danger:hover {
  background: #ff6b6b;
  border-color: #ff6b6b;
}
</style>